// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Meta resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient } from '../http.js';

export class MetaClient {
  constructor(private readonly http: HttpClient) {}

  /** Intercom messenger boot config for the signed-in customer: app id + the server-computed identity-verification HMAC (user_hash). enabled:false (and no hash) until INTERCOM_IDENTITY_SECRET is configured — the messenger must never boot without identity verification. */
  async getMessengerConfig(): Promise<{ enabled: boolean; appId: string; userHash: string; email: string }> {
    return this.http.get<{ enabled: boolean; appId: string; userHash: string; email: string }>('/v1/support/messenger');
  }
}
